import { render } from "./AdvancedGuestTrafficForm.vue?vue&type=template&id=3bfafae9&scoped=true"
import script from "./AdvancedGuestTrafficForm.vue?vue&type=script&lang=js"
export * from "./AdvancedGuestTrafficForm.vue?vue&type=script&lang=js"

import "./AdvancedGuestTrafficForm.vue?vue&type=style&index=0&id=3bfafae9&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfafae9"]])

export default __exports__